import { FC, useMemo } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { UserList } from "./components";
import styles from "./UserRating.module.scss";
import { User } from "@entities/user";
import { useUserRatingPagination } from "./hooks/useUserRatingPagination";
import { REACTIONS_TYPES } from "@shared/constants";

export const UserRatingPage: FC = () => {
  const navigate = useNavigate();

  const {
    listEndRef,
    reactions,
    loading,
    error,
    isError,
    hasMoreData,
    isInitialLoad,
  } = useUserRatingPagination(REACTIONS_TYPES.UserRating);

  const pageVariants = {
    initial: {
      opacity: 0,
      y: 20,
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.4, 0, 0.2, 1],
        staggerChildren: 0.1,
      },
    },
    exit: {
      opacity: 0,
      y: -20,
      transition: {
        duration: 0.3,
        ease: [0.4, 0, 0.2, 1],
      },
    },
  };
  const users: User[] = useMemo(() => {
    if (!reactions) return [];
    if (reactions.data && Array.isArray(reactions.data)) {
      return reactions.data as unknown as User[];
    }
    if (Array.isArray(reactions)) {
      return reactions as unknown as User[];
    }
    return [];
  }, [reactions]);

  if (isError && error) {
    console.error(error);
    navigate("/unknownError");
    return null;
  }

  return (
    <motion.div
      className={styles.communityContainer}
      initial="hidden"
      animate="animate"
      exit="exit"
      variants={pageVariants}
    >
      <UserList
        users={users}
        listEndRef={listEndRef as React.RefObject<HTMLDivElement>}
        loading={loading}
        hasMoreData={hasMoreData}
        isInitialLoad={isInitialLoad}
      />
    </motion.div>
  );
};
